/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicLeak
 */
export interface PublicLeak {
    /**
     * 
     * @type {number}
     * @memberof PublicLeak
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof PublicLeak
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof PublicLeak
     */
    password?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicLeak
     */
    source: number;
    /**
     * 
     * @type {string}
     * @memberof PublicLeak
     */
    readonly sourceName: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicLeak
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicLeak
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicLeak
     */
    foundDate?: Date | null;
}

/**
 * Check if a given object implements the PublicLeak interface.
 */
export function instanceOfPublicLeak(value: object): value is PublicLeak {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('sourceName' in value) || value['sourceName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PublicLeakFromJSON(json: any): PublicLeak {
    return PublicLeakFromJSONTyped(json, false);
}

export function PublicLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identifier': json['identifier'],
        'password': json['password'] == null ? undefined : json['password'],
        'source': json['source'],
        'sourceName': json['source_name'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'foundDate': json['found_date'] == null ? undefined : (new Date(json['found_date'])),
    };
}

  export function PublicLeakToJSON(json: any): PublicLeak {
      return PublicLeakToJSONTyped(json, false);
  }

  export function PublicLeakToJSONTyped(value?: Omit<PublicLeak, 'id'|'source_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'password': value['password'],
        'source': value['source'],
        'found_date': value['foundDate'] == null ? undefined : ((value['foundDate'] as any).toISOString().substring(0,10)),
    };
}

